import React from 'react'
// import QuestionGrid from './QuestionGrid'
import QuestionManagement from './QuestionGrid';

export default function Question() {
  return (
    <div>
      <QuestionManagement />
    </div>
  );
}
